import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CookiebotInitService {
  initCookiebot(cookiebotId: string): Observable<void> {
    return new Observable((observer) => {
      if (!cookiebotId) {
        observer.next();
        observer.complete();
        return;
      }

      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.log('Skipping Cookiebot: running on localhost');
        observer.next();
        observer.complete();
        return;
      }

      // Detect Flutter native app wrapping
      const isFlutterApp = (window as any).flutter_inappwebview != null;

      if (isFlutterApp) {
        console.log('Skipping Cookiebot: running inside Native app');
        observer.next();
        observer.complete();
        return;
      }

      if (document.getElementById('Cookiebot')) {
        observer.next();
        observer.complete();
        return;
      }

      const script = document.createElement('script');
      script.id = 'Cookiebot';
      script.src = 'https://consent.cookiebot.com/uc.js';
      script.type = 'text/javascript';
      script.setAttribute('data-cbid', cookiebotId);

      // Use manual mode not auto to have more control over when cookies are set
      // script.setAttribute('data-blockingmode', 'auto');
      script.setAttribute('async', '');

      script.onload = () => {
        console.log('Cookiebot loaded');
        observer.next();
        observer.complete();
      };

      script.onerror = () => {
        console.warn('Cookiebot failed to load');
        try {
          const err = new Error('Cookiebot failed to load');
          Sentry.addBreadcrumb({
            category: 'cookiebot',
            message: 'Cookiebot failed to load',
            level: 'error',
          });
          Sentry.captureException(err);
        } catch {
          // swallow
        }

        observer.next(); // fail gracefully
        observer.complete();
      };

      // Important: insert it at the very top of <head>
      document.head.prepend(script);
    });
  }
}
